import type { AudioFontSchemaType, AudioSchemaType } from '@vedalib/editor/lib/brand'
import type { VideoFontSchemaType, VideoSchemaType } from '@vedalib/editor/lib/brand'
import type { VideoElementValue } from '@vedalib/editor/lib/elements'
import { FileUsageSource } from '@vedalib/editor/lib/files'
import React from 'react'

import DemoWrapper from 'components/Editor/EditorElements/decorators/DemoWrapper'
import type { FCDemoType } from 'components/Editor/EditorElements/elements.types'
import { useBrandTheme } from 'services/Branding/hooks'
import { DEMO_MODE } from 'services/Store/Project/constants'

import Element from './MediaElement'
import type { MediaDemoType } from './mediaTypes'

const fileValue = {
  source: FileUsageSource.file,
  id: '',
}

const Demo = (TYPE: 'audio' | 'video'): MediaDemoType => {
  const Component: FCDemoType<
    AudioSchemaType | VideoSchemaType,
    AudioFontSchemaType | VideoFontSchemaType,
    AudioFontSchemaType | VideoFontSchemaType
  > = ({ styles, fonts, feedback }) => {
    const theme = useBrandTheme()

    const DEMO_VALUE_VIDEO: VideoElementValue = {
      playbackRate: 1,
      controls: true,
      autoPlay: false,
      repeat: false,
      volume: 50,
      file: fileValue,
      coverImage: null,
      captions: null,
      overlay: theme.neutralColor,
      displayPlayback: true,
    }
    return (
      <DemoWrapper>
        <Element
          element={{
            id: `${TYPE}-demo`,
            type: TYPE,
            value: DEMO_VALUE_VIDEO,
            style: {},
            font: {},
            feedback: {},
          }}
          feedback={feedback}
          font={fonts}
          mode={DEMO_MODE}
          state={{ duration: 0, originalDuration: 0 }}
          styles={styles}
        />
      </DemoWrapper>
    )
  }

  return Component
}

export default Demo
